export default "__VITE_ASSET__ONl0Gmiu__"